import { QuestionnaireType } from 'modules/forms/components/newFormEditor/types'

import FormEditor from 'modules/procurement/components/FormEditor'

interface Props {
  state: QuestionnaireType
  setState: (state: QuestionnaireType) => void
}

const FormTab = (props: Props) => {
  return <FormEditor state={props.state} setState={props.setState} />
}

export default FormTab
